// src/store/reducers/matchesReducer.js
import { GET_MATCHES_REQUEST, GET_MATCHES_SUCCESS, GET_MATCHES_FAIL, ADD_MATCH, UPDATE_MATCH, DELETE_MATCH } from "../actions/matchesActions";

const initialState = { loading: false, list: [], error: null };

export default function matchesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MATCHES_REQUEST:
      return { ...state, loading: true };
    case GET_MATCHES_SUCCESS:
      return { ...state, loading: false, list: action.payload || [] };
    case GET_MATCHES_FAIL:
      return { ...state, loading: false, error: action.payload };
    case ADD_MATCH:
      return { ...state, list: [action.payload, ...state.list] };
    case UPDATE_MATCH:
      return { ...state, list: state.list.map((m) => (m._id === action.payload._id ? action.payload : m)) };
    case DELETE_MATCH:
      return { ...state, list: state.list.filter((m) => m._id !== action.payload._id) };
    default:
      return state;
  }
}
